import { entriesToSingleFieldObjArray } from '@/common/lib/array';
import { SendAnalitics } from '@/common/lib/playdeck';
import { getMainRollDiceAnaliticReward } from '@/common/lib/roll-craft';
import {
  type CollectCardGameRewardsResponseType,
  type MiniGameDiceRollResponseType,
  type RollDiceResponseType,
  type SaveAfterBombEventResponseType,
} from '@/common/types/dice-game';
import { type OnQueryStartedHandler } from '@/common/types/query/common';
import { type RootState } from '@/redux/store';

const rollDiceHandler: OnQueryStartedHandler<
  number,
  RollDiceResponseType
> = async (multiplier, { queryFulfilled }) => {
  try {
    const { data } = await queryFulfilled;
    const analytics = getMainRollDiceAnaliticReward(data);

    if (analytics) {
      SendAnalitics.rollCraftPlay({
        multiplier,
        ...analytics,
      });
    }
  } catch (error) {
    console.error(error);
  }
};

const miniGameRollDiceHandler: OnQueryStartedHandler<
  void,
  MiniGameDiceRollResponseType
> = async (_, { queryFulfilled }) => {
  try {
    const { data } = await queryFulfilled;

    if (!data.movesLeft) {
      const rewardType = Object.keys(data.reward[0])[0];
      const rewardValue = data.reward.reduce(
        (prev, curr) =>
          'tgem' in curr
            ? curr.tgem + prev
            : 'str' in curr
              ? curr.str + prev
              : prev,
        0,
      );

      SendAnalitics.rollCraftPlay({
        multiplier: 1,
        reward_type: rewardType,
        reward: [
          {
            [rewardType]: rewardValue,
          },
        ],
      });
    }
  } catch (error) {
    console.error(error);
  }
};

const collectCardGameHandler: OnQueryStartedHandler<
  void,
  CollectCardGameRewardsResponseType
> = async (_, { queryFulfilled }) => {
  try {
    const { data } = await queryFulfilled;

    SendAnalitics.rollCraftPlay({
      multiplier: 1,
      reward_type: data.type,
      reward: Object.entries(data.totalReward).map(
        entriesToSingleFieldObjArray,
      ),
    });
  } catch (error) {
    console.error(error);
  }
};

const safeAfterBombHandler: OnQueryStartedHandler<
  void,
  SaveAfterBombEventResponseType
> = async (_, { queryFulfilled, getState }) => {
  try {
    const currentGame = (getState() as RootState).diceGame.miniGame?.type;
    const { data } = await queryFulfilled;

    SendAnalitics.rollCraftPlay({
      multiplier: 1,
      reward_type: currentGame || '',
      reward: Object.entries(data.totalReward).map(
        entriesToSingleFieldObjArray,
      ),
    });
  } catch (error) {
    console.error(error);
  }
};

export {
  collectCardGameHandler,
  miniGameRollDiceHandler,
  rollDiceHandler,
  safeAfterBombHandler,
};
